import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=236f4926&scoped=true"
import script from "./TableRow.vue?vue&type=script&lang=js"
export * from "./TableRow.vue?vue&type=script&lang=js"
import style0 from "./TableRow.vue?vue&type=style&index=0&id=236f4926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f4926",
  null
  
)

export default component.exports